import React from 'react';
import '../css/Autoplaycarousel.css';
import CarouselItem from './CarouselItem';

const cardDetails = {
  0: {
    imgUrl: require('./CarouselImages/cnc_machining.webp'),
    title: 'CNC Machining',
  },
  1: {
    imgUrl: require('./CarouselImages/human_machine.webp'),
    title: 'Human Machine Interface',
  },
  2: {
    imgUrl: require('./CarouselImages/sheet_metal.webp'),
    title: 'Sheet Metal',
  },
  3: {
    imgUrl: require('./CarouselImages/steel_tube.webp'),
    title: 'Steel Tube Making',
  },
  4: {
    imgUrl: require('./CarouselImages/3d_printing.webp'),
    title: '3D Printing',
  },
  5: {
    imgUrl: require('./CarouselImages/metal_printing.webp'),
    title: 'Metal  Printing',
  },
  6: {
    imgUrl: require('./CarouselImages/stamping.webp'),
    title: 'Stamping',
  },
  7: {
    imgUrl: require('./CarouselImages/injection_molding.webp'),
    title: 'Injection Molding',
  },
  8: {
    imgUrl: require('./CarouselImages/silicone_tubing.webp'),
    title: 'Silicone Tubing',
  },
};

export default function AutoplayCarousel() {
  return (
    <div className="carousel-container">
      <div className="carousel-track">
        {Object.keys(cardDetails).map((detailKey) => (
          <CarouselItem
            key={detailKey}
            imgUrl={cardDetails[detailKey].imgUrl}
            imgTitle={cardDetails[detailKey].title}
            imgHeading={cardDetails[detailKey].title}
          />
        ))}
        {Object.keys(cardDetails).map((detailKey) => (
          <CarouselItem
            key={detailKey}
            imgUrl={cardDetails[detailKey].imgUrl}
            imgTitle={cardDetails[detailKey].title}
            imgHeading={cardDetails[detailKey].title}
          />
        ))}
      </div>
    </div>
  );
}
